<div class="loading-ticket-gif">
  <div class="lds-ring">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
  <div class="loading-text">{{ 'Loading_Ticket_Dialog1' | translate }}</div>
  <div class="loading-text" style="margin-top: 10px">
    {{ 'Loading_Ticket_Dialog2' | translate }}
  </div>
</div>
